<template>
  <modal-component ref="privacyModal" :title="$t('navigation.privacyPolicyAndTerms')">
    <div v-html="privacyContent"/>
  </modal-component>
  <a v-if="config.PRODUCTION_READY" target="_privacy" href="https://www.fiestaplop.com/privacy">{{$t('navigation.privacyPolicy')}}</a>
</template>
<script setup lang="ts">
import {ref} from "vue";
import useConfig from "~/config/useConfig";
// import api from "~/api";

const privacyModal = ref(null);
const privacyContent = ref('');
const config = useConfig();
// const showPrivacyModal = async () => {
//   const privacy = await api.TermsAndConditions.getTermAndConditionByLanguage('es');
//   privacyContent.value = privacy.data.content;
//   privacyModal.value.openModal()
// }
</script>